<template>
    <div class="prijava">

        <template v-if="pageState == 'success'">
            <successScreen></successScreen>
        </template>

        <template v-if="pageState == 'error'">
            <errorScreen v-on:close_overlay="resetState"></errorScreen>
        </template>

        <!-- navbar -->
        <Navbar></Navbar>

        <div class="container cf">
            <!-- counter pitanja -->
            <div class="counter">
                <div class="counter-divs cf">
                    <div class="counter">
                        <div>
                            <p>
                                Vrijeme za  <br>predaju: <br>
                                <span class="af">{{ values.leftValue }}</span> <span>{{ values.rightValue }}</span><br>
                                <small>{{ values.leftDesc }}</small> <small>{{ values.rightDesc }}</small>
                            </p>
                        </div>
                    </div>
                </div>
            </div>

            <div>
                <div class="bonus">
                    <span class="pic icon-cup"></span>
                    <p class="name"> Želiš li Bonus bodove? </p>
                    <p> Mudro iskoristi jokere! U tijeku jedne sezone možeš iskoristiti 3 jokera, a u svakom kolu možeš koristiti samo jedan.</p>
                    <ul class="cf">
                        <li @click.prevent="setBonusType('times_three')">
                            <a href="#" v-bind:class="{'active': bonusType == 'times_three'}">
                                3x bodovanje
                                <span>
                                    Odaberi jedno pitanje i utrostruči broj bodova. Ovaj joker možeš iskoristiti samo jednom u sezoni!
                                </span>
                            </a>
                        </li>
                        <li @click.prevent="setBonusType('wild_card')">
                            <a href="#" v-bind:class="{'active': bonusType == 'wild_card'}" >
                                Wild card
                                <span>
                                    Odaberi jedno pitanje za koje misliš da si pogrešno odgovorio,
                                    a Toni će ga priznati kao točno. Pametno odaberi!
                                </span>
                            </a>
                        </li>
                        <li @click.prevent="setBonusType('plus_30_seconds')" class="m-top">
                            <a href="#" v-bind:class="{'active': bonusType == 'plus_30_seconds'}" >
                                +30 sekundi
                                <span>
                                    Ovim jokerom dobivaš 30 sekundi i dodatnih bodova po svakom
                                    točno odgovorenom pitanju.
                                </span>
                            </a>
                        </li>
                    </ul>
                </div>

                <p class="loading" v-if="loading">Učitavanje odgovora...</p>
                <ul class="cards">
                    <ProbnaPrijavaPitanjaSingle v-for="(question, questionKey) in questions"
                    v-bind:key="questionKey"
                    :questionKey="questionKey"
                    :bonusType="bonusType"
                    :question="question"
                    :setMultiplier="setMultiplier"
                    :multiplier="question.multiplier"
                    :wildCard="question.wildCard"
                    :setWildCard="setWildCard"></ProbnaPrijavaPitanjaSingle>
                </ul>

                <div class="button" @click.prevent="turnInAnswers">
                    <a href="#" class="button-1 red"><span>Završi/predaj kviz</span></a>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
import Navbar from '../components/Navbar.vue'
import successScreen from '../components/SuccessScreen.vue'
import errorScreen from '../components/ErrorScreen.vue'
import ProbnaPrijavaPitanjaSingle from './ProbnaPrijavaPitanjaSingle.vue'
import { ApplicationState } from '../application-state'
import { TimeUtils, DDHHMMSSCounterValues } from '../utils/timeUtils'
import { BonusType } from '../utils/bonusType'
import exampleQuestions from '@/assets/probna-pitanja.json'

const TurnInState = {
    TURNING_IN: 'turning_in',
    ERROR: 'error',
    SUCCESS: 'success'
}
export default {
    name: 'probna-prijava-pitanja',
    data: function () {
        return {
            pageState: TurnInState.TURNING_IN,
            bonusType: BonusType.NONE,
            loading: true,
            counterInterval: 0,
            counterTime: 300,
            values: {},
            questions: exampleQuestions
        }
    },
    components: {
        Navbar,
        successScreen,
        errorScreen,
        ProbnaPrijavaPitanjaSingle
    },
    watch: {
        pageState (after) {
            if (after === TurnInState.SUCCESS) {
                setTimeout(() => {
                    this.$store.state.exampleRoundStatus = 0
                    this.$router.replace({ name: 'home' })
                }, 3000)
            }
        },
        appState (after, before) {
            if (before === ApplicationState.LOADING_DATA) {
                this.initialLoadata()
            }
        }
    },
    computed: {
        appState () {
            return this.$store.state.appState
        }
    },
    methods: {
        clearBonusType () {
            for (let q in this.questions) {
                this.$set(this.questions[q], 'wildCard', false)
                this.$set(this.questions[q], 'multiplier', false)
            }
        },

        setBonusType (bonusType) {
            this.clearBonusType()
            if (bonusType === this.bonusType) {
                this.bonusType = BonusType.NONE
            } else {
                this.bonusType = bonusType
            }
        },

        async getQuestions () {
            this.loading = true
            try {
                for (let q in this.questions) {
                    this.$set(this.questions[q], 'wildCard', false)
                    this.$set(this.questions[q], 'multiplier', false)
                }
            } catch (error) {
                console.error(error)
            }
            this.loading = false
        },

        setMultiplier (questionKey) {
            let multiplier = this.questions[questionKey].multiplier
            for (let q in this.questions) {
                this.questions[q].multiplier = false
            }
            this.$set(this.questions[questionKey], 'multiplier', !multiplier)
        },

        setWildCard (questionKey) {
            let wildCard = this.questions[questionKey].wildCard
            for (let q in this.questions) {
                this.questions[q].wildCard = false
            }
            this.$set(this.questions[questionKey], 'wildCard', !wildCard)
        },

        async turnInAnswers () {
            this.pageState = TurnInState.SUCCESS
        },

        resetState () {
            this.pageState = TurnInState.TURNING_IN
        },

        initialLoadata () {
            try {
                this.activateState = 'failed'
                this.getQuestions()
            } catch (error) {}
        },
        counter () {
            if (this.counterTime > 0) {
                let timeObject = TimeUtils.secondsToTimeObject(this.counterTime)
                this.values = DDHHMMSSCounterValues(timeObject)
            } else {
                this.values = DDHHMMSSCounterValues(TimeUtils.secondsToTimeObject(0))
                this.turnInAnswers()
            }
            this.counterTime--
        }
    },
    mounted () {
        this.loading = true
        if (this.appState !== ApplicationState.LOADING_DATA) {
            this.initialLoadata()
        }

        this.counter()
        this.counterInterval = setInterval(() => {
            this.counter()
        }, 1000)
    },
    beforeDestroy: function () {
        clearInterval(this.counterInterval)
    }

}
</script>

<style lang="scss" scoped>
.loading {
    display: block;
    position: relative;
    border-radius: 7px;
    padding: 11px 12px 54px;
    font-family: "mPlus";
    font-size: 18px;
    line-height: 22px;
    letter-spacing: -.2px;
    color: #fff;
    text-align: center;
}
.prijava {
    padding-top: 14px;
    padding-bottom: 24px;
    text-align: left;

    .counter {
        margin-bottom: 64px;
    }
    .button {
        text-align: center;

        a {
            min-width: 248px;
        }
    }
    .title {
        font-family: "mPlus";
        font-size: 18px;
        line-height: 22px;
        letter-spacing: -.2px;
        color: #fff;
        margin-bottom: 16px;
    }
    .text {
        font-family: "axiforma";
        font-size: 12px;
        line-height: 18px;
        letter-spacing: .3px;
        color: #fff;
        margin-bottom: 64px;
    }
    .bonus {
        position: relative;
        box-shadow: 0px 9px 16px 0px rgba(0,0,0,0.16);
        background-color: #fff;
        border-radius: 5px;
        padding: 54px 12px 9px;
        margin-top: 30px;
        margin-bottom: 90px;

        .pic {
            display: block;
            position: absolute;
            left: calc(50% - 40px);
            top: -30px;
            width: 80px;
            height: 80px;
            border-radius: 50%;
            border: 5px solid #fff;
            background-color: #fff;
            background-position: 50%;
            background-size: contain;
        }
        .name {
            text-align: center;
            font-family: "axiforma";
            font-size: 16px;
            letter-spacing: .3px;
            color: #000;
            margin-bottom: 10px;
        }
        ul {
            display: flex;
            flex-wrap: wrap;
            margin-left: -12px;
            margin-bottom: -50px;

            li {
                float: left;
                width: 50%;
                padding-left: 12px;
            }
            a {
                transition: opacity .4s ease-in-out;
                box-shadow: 0px 18px 40px 0px rgba(255,0,29,0.33);
                display: block;
                position: relative;
                border-radius: 7px;
                padding: 11px 12px 54px;
                font-family: "mPlus";
                font-size: 18px;
                line-height: 22px;
                letter-spacing: -.2px;
                background: linear-gradient(135deg, #ff0084 0%, #ff001d 100%);
                color: #fff;
                height: 100%;

                span {
                    font-family: "axiforma";
                    font-size: 12px;
                    line-height: 17px;
                    letter-spacing: .3px;
                }
                &:after {
                    content: '';
                    position: absolute;
                    left: calc(50% - 10.5px);
                    bottom: 19px;
                    width: 21px;
                    height: 21px;
                    background: url(~@/assets/img/icons/checkbox-2.png) 50% no-repeat;
                    background-size: contain;
                }
            }
            a.active:after {
                background: url(~@/assets/img/icons/checkbox-checked-2.png) 50% no-repeat;
                background-size: contain;
            }
        }
    }
    ul.cards {
        position: relative;
        margin-bottom: 30px;
    }
}
.m-top {
    margin-top: 20px;
}

.counter-divs {
    font-family: "mPlus";
    text-align: left;
    margin-left: -24px;
    font-size: 14px;
    letter-spacing: -.2px;
    display: block;
    max-width: 180px;

    > div {
        padding-left: 24px;
    }
    .counter {
        div {
            box-shadow: 0px 18px 24px 0px rgba(0,0,0,0.34);
            padding: 16px 14px 14px;
            background-color: #001840;
            color: #fff;
            border-radius: 10px;
            height: 100%;
        }
        p {
            margin: 0;
            white-space: nowrap;

            span {
                font-size: 25px;
                display: inline-block;
                margin: 5px 0 2px;
                min-width: 46px;
            }
            span.af:after {
                content: ':';
            }
            small {
                font-family: "axiforma";
                display: inline-block;
                text-transform: uppercase;
                font-size: 10px;
                letter-spacing: 1px;
                color: #85c0f8;
                min-width: 46px;
            }
        }
    }
}

@media only screen and (min-width: 800px) {
    .prijava {
        max-width: 1280px;
        margin: auto;
        .container {
            > div:nth-child(1) {
                float: left;
                width: 300px;
                padding-top: 30px;
            }
            > div:nth-child(2) {
                float: right;
                width: calc(100% - 332px);
            }
        }
        .bonus ul a:hover {
            opacity: 0.75;
        }
    }
}
@media only screen and (max-width: 480px) {
    .prijava {
        .bonus ul li {
            width: 100%;
            margin-bottom: 20px;
        }
        .bonus ul li.m-top {
            margin-top: 0;
        }
    }
}
</style>
